<template>

<app-table empty-message="This attendee has not volunteered for any roles." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column />

		<app-table-column text="Role" />

		<app-table-column text="Slot" />

	</app-table-head>

	<app-table-body>

		<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label :text="$constants.volunteers.assignment.statusName[item.status]" :type="$constants.volunteers.assignment.statusTheme[item.status]" :subtext="item.reference" />

			<app-table-cell-item type="convention/volunteers/role" :item="item.role" />
					
			<app-table-cell-item type="convention/volunteers/slot" :item="item.slot" empty-text="Not applicable" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px 1fr 1fr'
		}
	
	},

    methods: {
    
        onEditClick: function(item) {
        
            this.$router.push({
                name: 'Convention.Volunteers.Assignments.Edit',
                params: {
                    id: item
                }
            })
        
        }
    
    }

}

</script>

<style scoped>

</style>